import React from "react";
import classes from "./styles/NoPageFound.module.css";
import { useNavigate } from "react-router-dom";

const NoPageFound = () => {
  const navigate = useNavigate();
  return (
    <div className={classes.container}>
      <div className={classes.contentDiv}>
        <h1 className={classes.opps}>Oops!</h1>
        <div className={classes.section}>
          <h2 className={classes.number}>404</h2>
          <div className={classes.sorrySection}>
            <h3 className={classes.sorry}>Sorry</h3>
            <h3 className={classes.message}>This Page Does Not Exist</h3>
          </div>
          <button className={classes.button} onClick={() => navigate("/")}>
            Home{" "}
            <img
              src="/news-img/icons/top-right-arrow.svg"
              alt=""
              className={classes.arrow}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoPageFound;
